"use strict";
/*
 * Created on 06 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSiteNew_1 = require("../model/ProductSiteNew");

var ProductSiteNewConverter_1 = require("./ProductSiteNewConverter");
/**
 * Implementation of {@link ProductSiteNewConverter}.
 *
 * @author JMe
 */


var ProductSiteNewConverterImpl =
/*#__PURE__*/
function (_ProductSiteNewConver) {
  _inherits(ProductSiteNewConverterImpl, _ProductSiteNewConver);

  function ProductSiteNewConverterImpl() {
    _classCallCheck(this, ProductSiteNewConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteNewConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSiteNewConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        processed: source.processed
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductSiteNew_1.ProductSiteNew(ProductSiteNew_1.ProductSiteNew.schema.id.valueOf(conversions.documentToClassId(source)), ProductSiteNew_1.ProductSiteNew.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductSiteNew_1.ProductSiteNew.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), ProductSiteNew_1.ProductSiteNew.schema.processed.valueOfField(source));
    }
  }]);

  return ProductSiteNewConverterImpl;
}(ProductSiteNewConverter_1.ProductSiteNewConverter);

exports.ProductSiteNewConverterImpl = ProductSiteNewConverterImpl;